import React, { PureComponent, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import 'react-day-picker/lib/style.css'
import { SearchOutlined } from '@ant-design/icons'
import { Select, Col, Row } from 'antd'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'

import { Divider } from 'primereact/divider'
import { Checkbox } from 'primereact/checkbox'

import Draggable from 'react-draggable'
import Modal from 'react-bootstrap/Modal'
import DraggableModalDialog from '../common/DraggableModalDialog'
import { formatDate, parseDate } from 'react-day-picker/moment'
import ModalSMS from '../settings/ModalSMS'

// import TimePicker from 'react-times';
import moment from 'moment'

// CSS
import './ETimeForm.css'

import validate from './validation/validate-yup'
import getValidationSchema from './validation/getValidationSchema-yup'
import TimeUtils from '../../utils/TimeUtils'

import DatePicker from 'antd/lib/calendar'

class LeaveDetails extends PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        selectedOption: null,
        loaded: false,
        events: [],
        showModal: false,
        showNotifyWindow: false,
        hourStart: null,
        minuteStart: null,
        meridiemStart: null,
        focusedStart: false,
        timezoneStart: null,
        showTimezoneStart: false,
        hourEnd: null,
        minuteEnd: null,
        meridiemEnd: null,
        focusedEnd: false,
        timezoneEnd: null,
        showTimezoneEnd: false,
        showTimeSelector: false,
        showDuration: false,
        show: false,
        disableRemove: false,
        employee: '',
        event: {},
        actions: {},
        readOnly: false,
        leaveType: false,
        multipleDays: false,
        currentEmployee: null,
        disableEmployee: false,
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    // componentWillReceiveProps = props => {
    //     this.setState(props)
    // }
    componentDidMount() {
        // disableRemove = _.isEmpty(this.props.event.id)
        this.setState({ disableRemove: _.isEmpty(this.props.event.id) })

        // disable update by action type == 14 (normal work)
        // const user = JSON.parse(localStorage.getItem('user'))
        // if (user.role !== 0) {
        //     const actionType = this.props.event.actionType.value
        // if (99 == actionType && this.props.event.existing) {
        //     // disable update
        //     this.setState({ readOnly: true })
        // }
        // }

        if (this.props.readOnly) {
            this.setState({ readOnly: true })
        }

        if (this.props.event.source === 'timesheet') {
            this.setState({ readOnly: true })
        }

        // const leave = this.props.event.actionType.value < 99 ? true : false
        // this.setState({ leaveType: leave })
    }

    onTimeChangeStart = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourStart: hour,
            minuteStart: minute,
            meridiemStart: meridiem,
        })
    }

    onFocusChangeStart = focusedStart => {
        this.setState({ focusedStart })
    }

    onTimeChangeEnd = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourEnd: hour,
            minuteEnd: minute,
            meridiemEnd: meridiem,
        })
    }

    onFocusChangeEnd = focusedEnd => {
        this.setState({ focusedEnd })
    }

    // handleActionTypeChange = selectedOption => {
    //     this.setState({ selectedOption })
    //     console.log(`Option selected:`, selectedOption)
    // }

    castToViewModel = (data, employeeId) => {
        const vm = {}
        vm.id = this.props.event.id || ''
        vm.Title = data.title

        // const start = _.head(data.range)
        // const end = _.last(data.range)
        // vm.StartDate = moment(TimeUtils.combineDateNTime(start, data.startTime))
        // vm.EndDate = moment(TimeUtils.combineDateNTime(end, data.endTime))
        vm.StartDate = data.startDate
        vm.EndDate = data.endDate
        vm.ActionType = data.actionType.value
        vm.ActionHours = data.duration
        vm.allDay = true
        vm.Note = data.note
        vm.Status = 'edit'
        vm.Break = data.break
        vm.EmployeeID = employeeId
        vm.Hours = data.hours

        return vm
    }

    castToModel = data => {
        const vm = {}

        vm.employees = data.employee
        vm.startTime = data.startTime
        vm.endTime = data.endTime
        vm.PayrollEmpRosterStartDate = data.startDate
        vm.PayrollEmpRosterEndDate = data.endDate
        vm.PayrollEmpRosterActionNotes = data.note || ''
        vm.PayrollEmpRosterBreakMinute = _.toNumber(data.break) || 0
        vm.repeatEnd = data.repeatEnd

        return vm
    }

    castToUpdateModel = data => {
        const vm = {}

        vm.PayrollEmpRosterAutoID = data.id
        vm.PayrollEmpRosterEmployeeID = data.employeeID
        vm.PayrollEmpRosterStartDate = data.startDate
        vm.PayrollEmpRosterEndDate = data.endDate
        vm.PayrollEmpRosterActionNotes = data.note || ''
        vm.PayrollEmpRosterBreakMinute = _.toNumber(data.break) || 0
        vm.PayrollEmpRosterDispTitle = data.title

        return vm
    }

    handleETimeSubmitMulti = (data, setSubmitting) => {
        const { id } = data

        const selectedEmployees = this.props.selectedEmployees

        const startDate = data.startDate

        let start = moment(
            TimeUtils.combineDateNTime(startDate, data.startTime)
        )
        let end = moment(TimeUtils.combineDateNTime(startDate, data.endTime))

        if (end.isSameOrBefore(start)) {
            end = end.add(1, 'days')
        }

        data.startDate = start
        data.endDate = end

        // const payload = this.castToModel(data, selectedEmployees)
        // if id not defined, create
        if (!_.isNumber(id)) {
            const payload = this.castToModel(data, selectedEmployees)
            this.props.actions
                .addEvent(payload, this.props.weekView)
                .then(res => {
                    if (this.props.onSubmitRefresh) {
                        this.props.onSubmitRefresh()
                    }
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                    this.props.onHide()
                })
        } else {
            // update

            let employeeId = this.props.event.employeeID

            const emp = _.find(this.props.displayEmployees, {
                EmployeeAutoID: employeeId,
            })

            // data.startDate = moment(
            //     TimeUtils.combineDateNTime(start, data.startTime)
            // )
            // data.endDate = moment(TimeUtils.combineDateNTime(end, data.endTime))

            const startTime = data.startTime
            const endTime = data.endTime

            let title = `${startTime}-${endTime}:${emp.EmployeeFirstName} ${emp.EmployeeLastName}`
            data.title = title

            const payload = this.castToUpdateModel(data)
            payload.dateFrom = this.props.event.dateFrom
            payload.dateTo = this.props.event.dateTo

            this.props.actions
                .updateOne(payload, this.props.weekView)
                .then(res => {
                    this.props.onSubmitRefresh()
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                    this.props.onHide()
                })
        }
    }

    onDelete = event => {
        this.handleShow()
    }

    onCancel = evt => {
        this.props.onHide()
    }

    showNotify = () => {
        this.setState({ showNotify: true })
    }

    closeNotify = () => {
        this.setState({ showNotify: false })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.props.event.id, this.props.employee)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    handleActionTypeChange = (e, form) => {
        form.setFieldValue('actionType', e)
        const leave = e.value < 99 ? true : false
        this.setState({ leaveType: leave })
    }

    handleEmployeeChange = (e, form) => {
        form.setFieldValue('employee', e)
    }

    getEmployeeDefaultWorkHour = employeeId => {
        const employeeNormalWorkHours = this.props.payrollNormalWorkHour[
            employeeId
        ]
        if (!_.isEmpty(employeeNormalWorkHours)) {
            // year, month, date
            const evtYear = moment(this.props.event.start).year()
            const evtMonth = moment(this.props.event.start).month()
            const evtDate = moment(this.props.event.start).date()

            // local weekday
            const weekday = moment(this.props.event.start).weekday() + 1

            //PayrollEmpNormalWorkingHourStartTimeHour,PayrollEmpNormalWorkingHourStartTimeMinute

            const startTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeHour${weekday}`
                ]
            const startTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeMinute${weekday}`
                ]

            //[PayrollEmpNormalWorkingHourFinishTimeHour],[PayrollEmpNormalWorkingHourFinishTimeMinute1]
            const finishTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeHour${weekday}`
                ]
            const finishTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeMinute${weekday}`
                ]
            //[PayrollEmpNormalWorkingHourBreakMinute]
            const breakMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourBreakMinute${weekday}`
                ]

            // reset the start, end time
            //[year, month, day, hour, minute, second, millisecond]
            const evtStartTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                startTimeHour,
                startTimeMinute,
            ])
            const evtFinishTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                finishTimeHour,
                finishTimeMinute,
            ])

            // eTimeRequest
            const startTime = TimeUtils.extractTime(evtStartTime.toDate())
            const endTime = TimeUtils.extractTime(evtFinishTime.toDate())

            return { start: startTime, finish: endTime }
        }
        return {}
    }

    handlePeriodChange = (dates, dateStrings, form) => {
        form.setFieldValue('range', dates)
        const a = _.head(dates)
        const b = _.last(dates)
        const days = b.diff(a, 'days')
        if (days >= 1) {
            this.setState({ multipleDays: true })
        } else {
            this.setState({ multipleDays: false })
        }
    }

    onChange = (value, dateString) => {
        console.log('Selected Time: ', value)
        console.log('Formatted Selected Time: ', dateString)
    }
    onOk = value => {
        console.log('onOk: ', value)
    }

    onStartDateChange = (date, dateString, etimeForm) => {
        etimeForm.setFieldValue('startDate', date)
    }
    onEndDateChange = (date, dateString, etimeForm) => {
        etimeForm.setFieldValue('repeatEnd', date)
    }
    displayEmployees = () => {
        const empOption = this.props.displayEmployees.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    handleChange = value => {}

    periodEndingChange = value => {
        console.log(`selected ${value}`)
    }

    validateEmail = value => {
        let error
        if (!value) {
            error = 'Required'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            error = 'Invalid email address'
        }
        return error
    }

    validateFields = (values, props) => {
        const errors = {}

        // validate employee selection
        if (_.isArray(values.employee) && values.employee.length == 0) {
            errors.employee = 'Required'
        }

        // validate startTime
        if (_.isEmpty(values.startTime)) {
            errors.startTime = 'Invalid time'
        }

        // validate endTime
        if (_.isEmpty(values.endTime)) {
            errors.endTime = 'Invalid time'
        }

        // validate start date
        if (_.isEmpty(values.startDate)) {
            errors.startDate = 'Invalid date'
        } else if (!values.startDate.isValid()) {
            errors.startDate = 'Invalid date'
        }

        // validate repeatEnd
        if (!_.isEmpty(values.repeatEnd) && !values.repeatEnd.isValid()) {
            errors.repeatEnd = 'Invalid date'
        }

        // start date <= repeat end date
        if (!_.isEmpty(values.startDate) && values.startDate.isValid()) {
            if (!_.isEmpty(values.repeatEnd) && values.repeatEnd.isValid()) {
                const start = values.startDate
                const end = values.repeatEnd

                if (moment(end).isSameOrBefore(start, 'day')) {
                    errors.repeatEnd =
                        'Repeat end date should be after start date'
                }
            }
        }

        return errors
    }

    render() {
        const startDate = moment(this.props.event.dateFrom)
        const endDate = moment(this.props.event.dateTo)

        // find employee

        const employee = _.find(
            this.props.displayEmployees,
            emp => emp.EmployeeAutoID == this.props.event.employeeID
        )
        let employeeName = ''
        if (!_.isEmpty(employee)) {
            employeeName = employee.EmployeeName
        }
        const initialValues = {
            id: this.props.event.id,
            startDate: startDate,
            endDate: endDate,
            startTime: this.props.event.startTime,
            endTime: this.props.event.endTime,
            actionType: this.props.event.actionType,
            // hours: this.props.event.hours || 0,
            break: this.props.event.break || 0,
            title: employeeName,
            note: this.props.event.Note,
            employeeID: this.props.event.employeeID,
            existing: this.props.event.existing,
            approved: this.props.event.approved,
            hours: this.props.event.hours,
        }

        let multiple = false

        if (!moment(startDate).isSame(moment(endDate), 'day')) {
            multiple = true
        }

        // if (this.props.event.dateTo != undefined) {
        //     const endDate = moment(this.props.event.dateTo)
        //     initialValues.repeatEnd = endDate
        // }

        const showEmployee = this.props.showEmployee
        let employeeOptions = []
        if (showEmployee) {
            const empOption = this.props.displayEmployees.map(emp => {
                let o = {}
                o.label = emp.EmployeeName
                o.value = emp.EmployeeAutoID
                return o
            })
            employeeOptions = empOption

            if (_.isNumber(this.props.event.id)) {
                const employee = _.find(empOption, {
                    value: this.props.event.employeeID,
                })

                initialValues.employee = [employee.label]

                // this.setState({ disableEmployee: true })
            } else {
                initialValues.employee = this.props.selectedEmployees

                // const employeeID = _.head(this.props.selectedEmployees).code

                // const { start, finish } = this.getEmployeeDefaultWorkHour(
                //     employeeID
                // )
                // initialValues.startTime = start
                // initialValues.endTime = finish
            }
        }

        const { readOnly } = this.state
        return (
            <div className="form-container">
                <Formik initialValues={initialValues}>
                    {etimeForm => (
                        <Form layout="vertical">
                            {multiple ? (
                                <Row gutter={{ xs: 16, md: 24 }}>
                                    <Col xs={16} sm={16} md={24} lg={12}>
                                        <div className="form-field-container">
                                            <label className="form-field-label">
                                                Start Date
                                            </label>
                                            <div className="form-field-value">
                                                {etimeForm.values.startDate.format(
                                                    'DD/MM/YYYY'
                                                )}
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xs={16} sm={16} md={24} lg={12}>
                                        <div className="form-field-container">
                                            <label className="form-field-label">
                                                End Date
                                            </label>
                                            <div className="form-field-value">
                                                {etimeForm.values.endDate.format(
                                                    'DD/MM/YYYY'
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            ) : (
                                <Row gutter={{ xs: 16, md: 24, lg: 32 }}>
                                    <Col xs={16} sm={16} md={24} lg={32}>
                                        <div className="form-field-container">
                                            <label className="form-field-label">
                                                Date
                                            </label>
                                            <div className="form-field-value">
                                                {etimeForm.values.startDate.format(
                                                    'DD/MM/YYYY'
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}

                            <Row gutter={{ xs: 16, md: 24, lg: 32 }}>
                                <Col
                                    xs={16}
                                    sm={16}
                                    md={24}
                                    lg={32}
                                    style={{ overflow: 'hidden' }}
                                >
                                    <div className="form-field-container">
                                        <label className="form-field-label">
                                            Employee
                                        </label>
                                        <div className="form-field-value form-field-value-wide">
                                            {employeeName}
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={{ xs: 16, md: 24, lg: 32 }}>
                                <Col
                                    xs={16}
                                    sm={16}
                                    md={24}
                                    lg={32}
                                    style={{ overflow: 'hidden' }}
                                >
                                    <div className="form-field-container">
                                        <label className="form-field-label">
                                            Leave Type
                                        </label>
                                        <div className="form-field-value form-field-value-wide">
                                            {etimeForm.values.actionType
                                                ?.label ||
                                                etimeForm.values.actionType}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={{ xs: 16, md: 24, lg: 32 }}>
                                {!multiple && (
                                    <Col
                                        xs={16}
                                        sm={16}
                                        md={24}
                                        lg={32}
                                        style={{ overflow: 'hidden' }}
                                    >
                                        <div className="form-field-container">
                                            <label className="form-field-label">
                                                Hours
                                            </label>
                                            <div className="form-field-value">
                                                {etimeForm.values.hours || '0'}
                                            </div>
                                        </div>
                                    </Col>
                                )}
                            </Row>

                            <Row gutter={{ xs: 16, md: 32 }}>
                                <Col
                                    xs={24}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{ overflow: 'hidden' }}
                                >
                                    <div className="form-field-container">
                                        <label className="form-field-label">
                                            Approved
                                        </label>
                                        <div
                                            className=""
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}
                                        >
                                            <Checkbox
                                                checked={
                                                    etimeForm.values.approved
                                                }
                                                disabled={true}
                                                style={{
                                                    pointerEvents: 'none',
                                                }}
                                            />
                                            
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={{ xs: 16, md: 24, lg: 32 }}>
                                <Col xs={16} sm={16} md={24} lg={32}>
                                    <div className="form-field-container">
                                        <label className="form-field-label">
                                            Leave Reason
                                        </label>
                                        <div
                                            className="form-field-value form-field-value-wide"
                                            style={{ maxWidth: '100%' }}
                                        >
                                            {etimeForm.values.note || 'N/A'}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        displayEmployees: state.roster.displayEmployees,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
        selectedEmployees: state.roster.selectedEmployees,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaveDetails)
